@use '@/styles/tokens' as *;

// Figma switch (node 134:1974). sm/md map onto antd's small/default sizes via
// Switch tokens in src/config/theme.ts; antd has no third size, so lg is
// styled here. Off-state track color is a token-level assumption (see spec).

.wrapper {
  display: inline-flex;
  align-items: center;
  gap: $space-4;
}

.label {
  color: var(--text-primary);
}

.labelDisabled {
  color: var(--text-disabled);
}

.labelSm {
  font-size: 12px;
}

.labelMd {
  font-size: 14px;
}

.labelLg {
  font-size: 16px;
}

.switch:global(.ant-switch-disabled) {
  opacity: 0.5;
}

.lg {
  height: 24px;
  min-width: 48px;
  border-radius: 24px;

  :global(.ant-switch-handle) {
    width: 20px;
    height: 20px;
    inset-inline-start: 2px;
  }

  :global(.ant-switch-handle)::before {
    border-radius: 12px;
  }

  &:global(.ant-switch-checked) :global(.ant-switch-handle) {
    inset-inline-start: calc(100% - 22px);
  }
}
